import React, { useState, useRef } from "react";
import "../../styles/Form.css";

export default function Contact() {
  return (
      <div className="contact" id="contact">
            <h1 className="contact-head">Contact Me</h1>
            <p>If you're interested in working with me, I'd love to hear from you.</p>
            <p>Reach out to me at lvforsythe95@gmail.com</p>
      </div>
  );
}
